module.exports = "https://trybtryb-legacy.web.app/img/tryb.8601ec38.webp";